import { CPChecklistTaskModelType } from '@teinor/erp/types/company/customer/customerProject/cPChecklist/cPChecklistSection/cPChecklistTask'
import { useCallback } from 'react'
import { twinFetchPostJSON } from '../../../../../utils/globals/data'
import { ChangeCPChecklistTaskTy } from '../types'
import { SetCustomerProjectDataTy } from '../../types'
import { getUserPermissions } from '../../../../../utils/reducers/getters'
import ChecklistTask from '../../../../../baseComponents/Checklist/ChecklistTask'

interface CPChecklistTaskProps extends CPChecklistTaskLogicProps {
    addTask: ()=> void
}

const CPChecklistTask: React.FC<CPChecklistTaskProps> = ({ task, addTask, ...logic}) => {
    const { updateCPChecklistTask, deleteCPChecklistTask, userPermission, userPermissionCheck } = useCPChecklistTaskLogic({ task, ...logic })
    return (
        <ChecklistTask task={task} userPermission={userPermission} userPermissionCheck={userPermissionCheck} onChangeTask={updateCPChecklistTask} onDeleteTask={deleteCPChecklistTask} addTask={addTask} />
    )
}

interface CPChecklistTaskLogicProps {
    posChecklist: number
    posSection: number
    posTask: number
    CustomerProjectId: number
    task: CPChecklistTaskModelType
    setCustomerProjectData: SetCustomerProjectDataTy
}

const useCPChecklistTaskLogic = ({ posChecklist, posSection, posTask, task, setCustomerProjectData, CustomerProjectId }: CPChecklistTaskLogicProps) => {
    const userPermission = getUserPermissions('customer.projects.checklists')
    const userPermissionCheck = getUserPermissions('customer.projects.checklistmark')

    const handleCPChecklistTask: ChangeCPChecklistTaskTy = useCallback((field, value) => {
        setCustomerProjectData((old)=>{
            const copyOld = JSON.parse(JSON.stringify(old))
            const checklist = copyOld.CPChecklists[posChecklist]
            checklist.CPChecklistSections[posSection].CPChecklistTasks[posTask][field]= value
            return { ...copyOld }
        })
    }, [setCustomerProjectData, posChecklist, posSection, posTask])

    const updateCPChecklistTask: ChangeCPChecklistTaskTy = useCallback(async (field, value) => {
        if (value !== task[field]) {
            handleCPChecklistTask(field, value)
            await twinFetchPostJSON('/api/app/customer/customerProject/customerProjectChecklist/section/task/updateCPChecklistTask', { id: task.id, [field]: value, CustomerProjectId })
        }
    }, [task, handleCPChecklistTask, CustomerProjectId])

    const deleteCPChecklistTask = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/customer/customerProject/customerProjectChecklist/section/task/deleteCPChecklistTask', { id: task.id, CustomerProjectId })
        if (result) {
            setCustomerProjectData((old) => {
                const copyOld = JSON.parse(JSON.stringify(old))
                const checklist = copyOld.CPChecklists[posChecklist]
                checklist.CPChecklistSections[posSection].CPChecklistTasks.splice(posTask, 1)
                return { ...copyOld }
            })
        }
    }, [task.id, setCustomerProjectData, posChecklist, posSection, posTask, CustomerProjectId])

    return { updateCPChecklistTask, deleteCPChecklistTask, userPermission, userPermissionCheck }
}

export default CPChecklistTask